// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2017 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

// Import first party modules

import './header.scss';

const MODULE_NAME = 'header';
angular

    .module(MODULE_NAME, [
    ])

    .directive('appHeader', () => {
      return {
        restrict: 'E',
        scope: true,
        template: require('./header.html'),
        link: ($scope, element, attrs) => {},
      };
    });

export default MODULE_NAME;
